import { render, staticRenderFns } from "./MobilesViewsHistory.vue?vue&type=template&id=413b965f&scoped=true&"
import script from "./MobilesViewsHistory.vue?vue&type=script&lang=js&"
export * from "./MobilesViewsHistory.vue?vue&type=script&lang=js&"
import style0 from "./MobilesViewsHistory.vue?vue&type=style&index=0&id=413b965f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413b965f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('413b965f')) {
      api.createRecord('413b965f', component.options)
    } else {
      api.reload('413b965f', component.options)
    }
    module.hot.accept("./MobilesViewsHistory.vue?vue&type=template&id=413b965f&scoped=true&", function () {
      api.rerender('413b965f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/navigationhistory/MobilesViewsHistory.vue"
export default component.exports